
import WrenchIcon from "@/components/icons/WrenchIcon.vue";
import ZlotyIcon from "@/components/icons/ZlotyIcon.vue";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import { mapGetters } from "vuex";
import { defineComponent } from "vue";

export default defineComponent({
  components: { ZlotyIcon, WrenchIcon, PhoneIcon },
  computed: {
    ...mapGetters(["getPhoneNumber"]),
    ...mapGetters("cars", ["getSelectedCar"]),
  },
});
